// extracted by mini-css-extract-plugin
export default {"optionsBlock":"options_optionsBlock__tWtEE","options":"options_options__3EDjf","heading":"options_heading__5O4Xs"};